//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.PlanarOperationBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
let d=[[[1,"ClrHorizBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"ClrMinBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"ClrVertBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"CutlevMaxDepthBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"CutterCompensationAngle",1,0],[0,"CutterCompensationDist",1,0],[0,"CutterCompensationType",1,0],[1,"EngAutoHelicalDiameterBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"EngAutoMinRampLengthBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"EngAutoRampAngleBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"EngAutoRampMethod",1,0],[1,"EngretAutoActiveRangeBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"EngretAutoOverlapBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"EngretAutoRadiusBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"EngretAutoType",1,0],[1,"HoleDiamBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"PredrillHoleDiamBuilder",0,"CAM.InheritableDoubleBuilder",0],[1,"RetAutoDistBuilder",0,"CAM.InheritableDoubleBuilder",0],[0,"TransferMethod",1,0]],[],[]];
SPLM.CAM.FeatureMillingBuilder = class extends SPLM.CAM.PlanarOperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.FeatureMillingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.FeatureMillingBuilder.EngretAutoTypeTypes = Object.freeze({
    "Linear" : "Linear", "Circular" : "Circular"});

SPLM.CAM.FeatureMillingBuilder.TransferMethodTypes = Object.freeze({
    "ClearancePlane" : "ClearancePlane", "PreviousPlane" : "PreviousPlane", "BlankPlane" : "BlankPlane", "Direct" : "Direct"});

SPLM.CAM.FeatureMillingBuilder.EngAutoRampMethodTypes = Object.freeze({
    "OnLines" : "OnLines", "OnLinesAndArcs" : "OnLinesAndArcs", "HelicalRamping" : "HelicalRamping"});

SPLM.CAM.FeatureMillingBuilder.CutterCompensationTypes = Object.freeze({
    "None" : "None", "EngageRetract" : "EngageRetract", "AgainstWall" : "AgainstWall"});

export default SPLM;